<template>
  <div class="reportQuerySummary">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-tabs
      v-model="menuState"
      @change="stateChanged"
      title-active-color="#009ed4"
      color="#009ed4"
      swipeable
    >
      <van-tab
        v-for="(menu, index) in menuList"
        :key="index"
        :title="menu.title + (menu.count > 0 ? ' ' + menu.count : '')"
        :name="menu.name"
      >
        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          :finished-text="$t.meta.noMore"
          :error.sync="error"
          :error-text="errorText"
          @load="getList"
        >
          <div class="list-container" v-for="(item, index) in tableData" :key="index">
            <div class="checkBox" v-if="menuState == 2">
              <van-checkbox
                v-model="item.isSelected"
                @change="handleCheckBox"
                :disabled="item.IsPayrollRequestInApprovalProcess == 1 ? true : false"
              ></van-checkbox>
            </div>
            <div
              class="list-wrapper shadow"
              @click="gotoDetail(item)"
              v-if="menuState == 2"
            >
              <div class="list-item">
                {{ $t.reportQuerySummary.sideWbNumber }}：{{ item.WB_Number }}
              </div>
              <div class="list-item">
                {{ $t.reportQuerySummary.financialAccountNo }}：{{
                  item.FinancialAccountNo
                }}
              </div>
              <div class="list-item">
                {{ $t.reportQuerySummary.deliveryPort }}：{{ item.POL }}
              </div>
              <div class="list-item">
                {{ $t.reportQuerySummary.destinationPort }}：{{ item.POD }}
              </div>
              <div class="list-item">
                {{ $t.reportQuerySummary.createDate }}：{{ item.InvoiceDate }}
              </div>
              <div class="list-item">
                {{ $t.reportQuerySummary.payerName2 }}：{{ item.CompanyNameSn }}
              </div>
              <div class="list-item">
                {{ $t.reportQuerySummary.totalPayableBalance }} ({{
                  settlementCurrency
                }})：{{ item.PaymentBalance }}
              </div>
              <div class="list-item">
                {{ $t.reportQuerySummary.payrollRequest }}：<van-icon
                  name="success"
                  v-if="item.IsPayrollRequest"
                  color="#13ce66"
                  size="14"
                />
              </div>
            </div>
            <div
              class="list-wrapper"
              style="margin-top: 10px"
              @click="gotoDetail(item)"
              v-else
            >
              <div class="list-item">
                {{ $t.reportQuerySummary.invoiceNo }}：{{ item.InvoiceNo }}
              </div>
              <div class="list-item">
                {{ $t.reportQuerySummary.createDate }}：{{ item.InvoiceDate }}
              </div>
              <div class="list-item">
                {{ $t.reportQuerySummary.deliveryPort }}：{{ item.POL }}
              </div>
              <div class="list-item">
                {{ $t.reportQuerySummary.destinationPort }}：{{ item.POD }}
              </div>
              <div class="list-item">
                {{ $t.reportQuerySummary.total }} ({{ settlementCurrency }})：{{
                  item.InvoiceAmount
                }}
              </div>
              <div class="list-item">
                {{ $t.reportQuerySummary.payerName1 }}：{{ item.CompanyNameSn }}
              </div>
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            v-show="
              dataQueryCriteria == item.value ||
              item.value == 4 ||
              item.value == 5 ||
              item.value == 6
            "
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>

        <div class="radio-label">{{ $t.meta.statistics }}</div>
        <van-radio-group
          v-model="dataQueryCriteria"
          direction="horizontal"
          @change="statisticsChange"
        >
          <van-radio :name="0">{{ $t.reportQuerySummary.dataOtion0 }}</van-radio>
          <van-radio :name="1">{{ $t.reportQuerySummary.dataOtion1 }}</van-radio>
          <van-radio :name="2">{{ $t.reportQuerySummary.dataOtion2 }}</van-radio>
          <van-radio :name="3">{{ $t.reportQuerySummary.dataOtion3 }}</van-radio>
        </van-radio-group>

        <div class="radio-label">{{ $t.meta.customerTitle }}</div>
        <van-radio-group v-model="customerType" direction="horizontal">
          <van-radio :name="1">{{ $t.meta.enterprise }}</van-radio>
          <van-radio :name="2">{{ $t.meta.personal }}</van-radio>
        </van-radio-group>

        <div class="custom-date">
          <div class="date-label">{{ $t.meta.date }}</div>
          <van-button class="date-btn1" type="info" size="small" @click="showStartDate">{{
            $t.meta.beginDate
          }}</van-button>
          <van-button class="date-btn2" type="info" size="small" @click="showEndDate">{{
            $t.meta.endDate
          }}</van-button>
          <div class="date-txt" v-if="beginTime || endTime">
            {{ beginTime }} {{ $t.meta.to }} {{ endTime }}
          </div>
        </div>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <div class="tool-bar" v-if="menuState == 1">
      <div class="tool-bar-wrapper" v-if="showStatistics">
        <van-button block @click="showStatistics = false">{{
          $t.meta.hideStatistics
        }}</van-button>
        <div class="tool-bar-total" v-if="receiveList && receiveList.length > 0">
          <div class="tool-bar-total-left">
            {{ $t.reportQuerySummary.subTotal }}
          </div>
          <div
            class="tool-bar-total-item"
            v-for="(item, index) in receiveList"
            :key="index"
          >
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.TotalAmount }}</div>
          </div>
        </div>

        <div class="tool-bar-total" v-if="rateList && rateList.length > 0">
          <div class="tool-bar-total-left">
            {{ $t.reportQuerySummary.rate }}
          </div>
          <div class="tool-bar-total-item" v-for="(item, index) in rateList" :key="index">
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.Rate }}</div>
          </div>
        </div>

        <div class="tool-bar-total">
          <div class="tool-bar-total-left">
            {{ $t.reportQuerySummary.unreceiveTotal }}
          </div>
          <div class="tool-bar-total-item" style="width: 75%">
            <div class="item1">{{ settlementCurrency }}</div>
            <div class="item2">{{ totalAmount }}</div>
          </div>
        </div>
      </div>
      <div class="tool-bar-wrapper" v-else>
        <van-button type="info" block @click="showStatistics = true">{{
          $t.meta.showStatistics
        }}</van-button>
      </div>
    </div>
    <div class="tool-bar" v-if="menuState == 2">
      <div class="tool-bar-wrapper" v-if="showStatistics">
        <van-button block @click="showStatistics = false">{{
          $t.meta.hideStatistics
        }}</van-button>

        <div class="tool-bar-total" v-if="receiveList && receiveList.length > 0">
          <div class="tool-bar-total-left">
            {{ $t.reportQuerySummary.subTotal }}
          </div>
          <div
            class="tool-bar-total-item"
            v-for="(item, index) in receiveList"
            :key="index"
          >
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.TotalAmount }}</div>
          </div>
        </div>

        <div class="tool-bar-total" v-if="rateList && rateList.length > 0">
          <div class="tool-bar-total-left">
            {{ $t.reportQuerySummary.rate }}
          </div>
          <div class="tool-bar-total-item" v-for="(item, index) in rateList" :key="index">
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.Rate }}</div>
          </div>
        </div>

        <div class="tool-bar-total">
          <div class="tool-bar-total-left">
            {{ $t.reportQuerySummary.unreceiveTotal }}
          </div>
          <div class="tool-bar-total-item" style="width: 75%">
            <div class="item1">{{ settlementCurrency }}</div>
            <div class="item2">{{ totalAmount }}</div>
          </div>
        </div>
      </div>
      <div class="tool-bar-wrapper" v-else>
        <van-button
          type="info"
          class="confirm-button"
          block
          @click="toPayrollDetails"
          :disabled="financialAccountNoList.length > 0 ? false : true"
          >{{ $t.reportQuerySummary.bill }}</van-button
        >
        <van-button
          type="info"
          class="statistics-button"
          block
          @click="showStatistics = true"
          >{{ $t.meta.showStatistics }}</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  ActionSheet,
  Popup,
  DatetimePicker,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  Checkbox,
  Icon,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup)
  .use(Tab)
  .use(Tabs)
  .use(Checkbox)
  .use(Icon);

export default {
  name: "reportQuerySummary",
  data() {
    return {
      menuState: this.$route.query.state
        ? this.$route.query.state
        : parseInt(localStorage.getItem("MenuState")),
      menuList: [
        {
          title: this.$t.reportQuerySummary.tab1,
          name: 1,
          count: 0,
        },
        {
          title: this.$t.reportQuerySummary.tab2,
          name: 2,
          count: 0,
        },
      ],
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //统计
      showStatistics: false,
      settlementCurrency: "",
      receiveList: [],
      rateList: [],
      totalAmount: null,
      //filter
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.reportQuerySummary.invoiceNo,
          value: 0,
        },
        {
          text: this.$t.reportQuerySummary.wbNumber,
          value: 1,
        },
        {
          text: this.$t.reportQuerySummary.warehouseWorkNumber,
          value: 2,
        },
        {
          text: this.$t.reportQuerySummary.jobNumber,
          value: 3,
        },
        {
          text: this.$t.reportQuerySummary.recommend,
          value: 4,
        },
        {
          text: this.$t.reportQuerySummary.customerNumber,
          value: 5,
        },
        {
          text: this.$t.reportQuerySummary.companyName,
          value: 6,
        },
      ],
      dataQueryCriteria: 1,
      customerType: null,
      showFilter: false,
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
      //生成请款单
      financialAccountNoList: [],
    };
  },
  watch: {
    menuState() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.getList();
    },
  },
  created() {
    this.defaultDate();
  },
  methods: {
    toPayrollDetails() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "payrollDetails",
        name: "payrollDetails",
        query: [
          {
            name: "FinancialAccountNoList",
            value: this.financialAccountNoList,
          },
          {
            name: "Type",
            value: "new",
          },
        ],
      });
    },
    handleCheckBox() {
      var number = [];
      var items = this.tableData.filter((p) => p.isSelected);
      for (var item of items) {
        number.push(item.FinancialAccountNo);
      }
      this.financialAccountNoList = number;
    },
    defaultDate() {
      let date = new Date();
      let year = date.getFullYear().toString();
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString();
      let da =
        date.getDate() < 10 ? "0" + date.getDate().toString() : date.getDate().toString();
      let end = year + "-" + month + "-" + da;
      let beg = year + "-" + month + "-01";
      this.beginTime = beg;
      this.endTime = end;
    },
    gotoDetail(item) {
      var data = item;
      data.menuState = this.menuState;
      data.SettlementCurrency = this.settlementCurrency;
      data.RateList = this.rateList;
      localStorage.setItem("reportQuerySummaryDetail", JSON.stringify(data));
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "reportQuerySummaryDetail",
        name: "reportQuerySummaryDetail",
        query: [],
      });
    },
    statisticsChange(e) {
      this.searchType = e;
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList();
    },
    isFilter() {
      if (this.customerType) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      this.customerType = null;
      this.dataQueryCriteria = 1;
      this.defaultDate();
      this.initList();
      this.getList();
    },
    filterSubmit() {
      this.initList();
      this.getList();
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    stateChanged(state) {
      this.menuState = state;
      localStorage.setItem("MenuState", JSON.stringify(state));
      this.searchText = "";
      this.searchType = 1;
    },
    getList() {
      var param = {
        CustomerType: this.customerType,
        DataQueryCriteria: this.dataQueryCriteria,
        InvoiceNo: this.searchType == 0 ? this.searchText : "",
        WB_Number: this.searchType == 1 ? this.searchText : "",
        WarehouseWorkNumber: this.searchType == 2 ? this.searchText : "",
        WorkOrderNumber: this.searchType == 3 ? this.searchText : "",
        Referrer: this.searchType == 4 ? this.searchText : "",
        CustomerNumber: this.searchType == 5 ? this.searchText : "",
        CompanyName: this.searchType == 6 ? this.searchText : "",
        BeginTime: this.beginTime,
        EndTime: this.endTime,
      };
      var request = null;
      if (this.menuState == 2) {
        request = this.$api.financialManagement.getPayablePaymentList(param);
      } else {
        request = this.$api.financialManagement.getReceivablePaymentList(param);
      }
      request
        .then((res) => {
          if (this.menuState == 2) {
            this.tableData = res.data.CostPayment.DetailList;
            this.receiveList = res.data.CostPayment.CostSubTotalList;
            this.totalAmount = res.data.CostTotalAmount;
          } else {
            this.tableData = res.data.ReceivablePayment.DetailList;
            this.receiveList = res.data.ReceivablePayment.ReceivableSubTotalList;
            this.totalAmount = res.data.ReceivableTotalAmount;
          }
          this.rateList = res.data.RateList;
          this.settlementCurrency = res.data.SettlementCurrency;
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.finished = true;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.reportQuerySummary {
  ::v-deep .van-radio__icon--disabled.van-radio__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-radio__label--disabled.van-radio__label {
    color: #999 !important;
    -webkit-text-fill-color: #999 !important;
  }
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      .checkBox {
        vertical-align: middle;
        display: inline-block;
        margin: 20px;
      }
      .shadow {
        box-shadow: 0px 2.5px 6.5px 1px rgb(0 0 0 / 10%);
      }
      .list-wrapper {
        font-size: 12px;
        color: #333;
        padding: 10px;
        box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
        .list-item {
          margin-bottom: 10px;
        }
        .list-item:last-child {
          margin-bottom: 0px;
        }
        .buttons {
          text-align: right;
          padding-bottom: 10px;
          .primary-btn {
            margin-top: 5px;
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-primary;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
          .default-btn {
            margin-top: 5px;
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-light-gray;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
          .search-btn {
            margin-top: 5px;
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-green;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
          .danger-btn {
            margin-top: 5px;
            margin-left: 5px;
            border-radius: 5px;
            background: $-color-red;
            border: none;
            .van-button__text {
              font-size: 14px !important;
            }
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tool-bar-total {
    font-size: 12px;
    color: #333333;
    background: #fff;
    .tool-bar-total-left {
      display: inline-block;
      width: 25%;
      text-align: center;
      vertical-align: middle;
      .checkbox {
        display: inline-flex;
        span {
          margin-left: 10px;
        }
      }
    }
    .tool-bar-total-item {
      display: inline-block;
      width: 25%;
      text-align: center;
      vertical-align: middle;
      .item1 {
        padding: 5px;
        background: #1e90ff;
        color: #ffffff;
      }
      .item2 {
        padding: 5px;
        background: #e8f4ff;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
    .tool-bar-wrapper {
      border-bottom: 1px solid #f6f6f6;
    }
    .confirm-button {
      background: #5029c3;
      color: #fff;
      border: none;
      display: inline-block;
      width: 50%;
    }
    .statistics-button {
      border: none;
      display: inline-block;
      width: 50%;
    }
  }
}
</style>
